export default __webpack_public_path__ + "static/spiral-2-ea582eecb0cb382d23b305bfd616b2cc.png";